import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import EmailSignatureModel from "../models/EmailSignatureModel";

export interface SaveEmailSignatureParam {
    id: string,
    name: string,
    signature: string,
    system: string,
}

export interface DeleteEmailSignatureParam {
    id: string,
}

export interface SetDefaultSignatureParam {
    id: string,
    system: string
}

const axiosConfig = {
    headers: {
        ignoreCredentials: true
    }
};

const EmailSignatureApi = {
    GetAll() {
        return Api.get<unknown, BaseResponse<EmailSignatureModel[]>>("/api/EmailSignature/GetAll", null);
    },
    Save(param: SaveEmailSignatureParam) {
        return Api.post<SaveEmailSignatureParam, BaseResponse<EmailSignatureModel>>("/api/EmailSignature/Save", param);
    },
    Delete(param: DeleteEmailSignatureParam) {
        return Api.post<DeleteEmailSignatureParam, BaseResponse<EmailSignatureModel>>("/api/EmailSignature/Delete", param);
    },
    SetDefaultSignature(param: SetDefaultSignatureParam) {
        return Api.post<SetDefaultSignatureParam, BaseResponse<EmailSignatureModel>>("/api/EmailSignature/SetDefaultSignature", param);
    },
};
export default EmailSignatureApi;